import { render, staticRenderFns } from "./Participacion.vue?vue&type=template&id=54393e19&"
import script from "./Participacion.vue?vue&type=script&lang=js&"
export * from "./Participacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports